import { useFormik } from 'formik';
import { usePathname } from 'next/navigation';
import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';
import placeOrder from '~/data/strapi/server-actions/order';
import { YMGoal, useMetrika } from '~/providers/ya-metrica';

interface Args {
  serviceName?: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const Schema = Yup.object().shape({
  phone: Yup.string()
    .test('phone-validation', 'Номер телефона указан неверно', (val) => (val ? isValidPhoneNumber(val) : true))
    .required('Поле обязательно для заполнения'),
  privacyPolicy: Yup.boolean().isTrue(),
});

const useCustomerForm = (args: Args) => {
  const { serviceName, onSuccess, onError } = args;
  const pathname = usePathname();
  const { captureGoal } = useMetrika();

  const formik = useFormik({
    initialValues: { name: '', phone: '', message: '', privacyPolicy: false },
    onSubmit: async (order, { resetForm }) => {
      const { name, phone, message } = order;
      if (!phone.length) return;

      const { isSuccess } = await placeOrder({ name, phone, message, linkFrom: pathname, serviceName });

      if (isSuccess) {
        onSuccess?.();
        resetForm();
        captureGoal(YMGoal.FORM_SUCCESS);
      } else {
        onError?.();
      }
    },
    validationSchema: Schema,
    enableReinitialize: true,
    isInitialValid: false,
    validateOnChange: false,
    validateOnBlur: true,
  });

  const { handleChange, values, handleBlur, handleSubmit, errors, submitCount, isSubmitting, setFieldValue } = formik;

  const showErrors = submitCount > 0;

  const handlePhoneChange = (num?: string) => {
    setFieldValue('phone', num);
  };

  return {
    handleChange,
    handlePhoneChange,
    handleSubmit,
    handleBlur,
    errors,
    showErrors,
    values,
    isSubmitting,
  };
};

export default useCustomerForm;
